<template>
  <div>
    <h2>{{ $t('W2P_RECIPIENTS') }}</h2>
    <p class="small paragraph">{{ $t('W2P_RECIPIENTS_DESCRIPTION_MANUAL') }}</p>
    <Recipient
      v-for="(recipient, index) in list"
      :key="index"
      :index="index"
      :recipient="recipient"
    />
    <RecipientForm
      v-if="showForm || !showAddButton"
      @submitted="showForm = false"
    />

    <pn-button-container
      v-if="showAddButton"
      class="add-button"
      secondary
      size="medium"
    >
      <button v-if="!showForm && list.length < 10" @click="toggleForm()">
        {{ $t('W2P_ADD_RECIPIENTS') }}
        <pn-icon symbol="plus" color="white" size="small" solid></pn-icon>
      </button>
    </pn-button-container>

    <div class="button-container">
      <pn-button-container secondary size="medium">
        <button @click="$router.push({ name: 'recipients' })">
          {{ $t('W2P_LETTER_BACK') }}
        </button>
      </pn-button-container>

      <pn-button-container @click="submit" size="medium" :loading="isLoading">
        <button :disabled="!list.length > 0" class="next">
          {{ $t('W2P_LETTER_NEXT') }}
        </button>
      </pn-button-container>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapState, mapMutations } from 'vuex'
import { getCountryName } from '@/helpers/country'
import Recipient from '@/components/letter/address/recipients/Recipient'
import RecipientForm from '@/components/letter/address/recipients/RecipientForm'

export default {
  data: () => ({
    showForm: false,
    isLoading: false
  }),
  computed: {
    ...mapState('letter/recipient', ['list']),
    ...mapState('letter/upload', ['letterOptions']),
    ...mapState('cart', ['serviceType']),
    showAddButton() {
      return this.list.length > 0
    }
  },
  components: {
    Recipient,
    RecipientForm
  },
  mounted() {
    this.SAVE_OPTION('recipients-manual')
  },
  methods: {
    ...mapMutations({
      saveAddresses(commit, payload) {
        return commit('letter/address/SAVE', payload)
      },
      resetUploadState(commit) {
        return commit('letter/address/RESET_STATE')
      }
    }),
    ...mapMutations('letter/address', ['SAVE_OPTION']),
    toggleForm() {
      this.showForm = !this.showForm
    },
    submit() {
      this.isLoading = true
      const addresses = this.mapForValidation()
      axios({
        method: 'post',
        url:
          process.env.VUE_APP_W2P_API_BASE_URL +
          '/recipients/v2/addresses/format/public',
        data: {
          service: this.serviceType,
          addresses: addresses
        }
      })
        .then(response => {
          this.resetUploadState()
          this.saveAddresses({ ...response.data, addressValidation: {} })
          this.$router.push({ name: 'delivery' })
          this.isLoading = false
        })
        .catch(() => {
          return
        })
    },
    mapForValidation() {
      const recipients = this.list.map(recipient => {
        let body = {
          name: recipient.name,
          addressRow2: recipient.address,
          addressRow3: recipient.addressOptional,
          zipCode: recipient.postalCode,
          city: recipient.city,
          country: getCountryName(recipient.country),
          countryCode: recipient.country
        }

        if (this.serviceType === 'paymentSlips') {
          const paymentSlipParams = this.getPaymentSlipParams(recipient)

          body = {
            ...body,
            ...paymentSlipParams
          }
        }

        return body
      })
      return recipients
    },
    getPaymentSlipParams(recipient) {
      const params = {
        'PostGiro/BankGiro': recipient.giroType,
        giroNumber: recipient.giroNumber,
        recipient: recipient.receiver,
        sum: recipient.sum,
        ocr: recipient.ocr
      }

      for (let i = 0; i < 6; i++) {
        params[`text${i + 1}`] = (recipient.text[i] || {}).value || ''
      }

      return params
    }
  }
}
</script>

<style lang="scss" scoped>
.paragraph {
  margin-top: 0.5em;
}

.add-button {
  margin-top: 1.5em;
  width: 100%;
}

.button-container {
  margin-top: 3.5em;
  width: 100%;
  display: flex;
  justify-content: space-between;

  pn-button-container {
    width: 70%;
    max-width: 15em;
    min-width: 0;
  }
}
</style>
